/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import { AiOutlineArrowRight, } from 'react-icons/ai';
import Logo from './image/Logo.webp'
import logo1 from './image/logo1.webp'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { BsTwitter } from 'react-icons/bs';
import { IoLogoInstagram } from 'react-icons/io';
import { MdOutlineSupportAgent, MdMailOutline } from 'react-icons/md';
import AOS from 'aos';
import 'aos/dist/aos.css';
import frontPage from './image/frontPage.png'
import { Helmet } from 'react-helmet';

class Home extends Component {

  constructor(props) {

    super(props);
    // this.props.dispatch(userActions.logout());
    this.loginSubmit = this.loginSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.state = {
      fieldslogin: {},
      errorslogin: {},
      otpSentLogin: false,
      shown: false,
      isMobileMenuOpen: false
    }
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
  }

  static getDerivedStateFromProps(nextProps) {

    if (nextProps.otpSentLogin) {
      return {
        ...nextProps,
        otpSentLogin: nextProps.otpSentLogin ? nextProps.otpSentLogin : false

      }
    } else {
      return {
        ...nextProps
      }
    }
  }


  inputChange(e) {
    e.preventDefault();
    let { name, value } = e.target;
    this.setState({ [name]: value });
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  }


  loginSubmit(e) {
    e.preventDefault();
    if (this.handleValidationLogin()) {
      let { email, password, } = this.state;
      this.props.dispatch(userActions.login({ email: email, password: password, }, this.props));
    }

  }

  resendSubmit = () => {
    if (this.handleValidationLogin()) {
      let { email, password, } = this.state;
      this.props.dispatch(userActions.login({ email: email, password: password, }, this.props));
    }

  }

  resetForm = (e) => {
    e.preventDefault();
    this.setState({
      fieldslogin: {},
      errorslogin: {},
    })
    this.hideErrorMessage();
  }


  handleValidationLogin = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Email
    if (!fieldslogin["email"] || fieldslogin["email"] === "") {
      formIsValid = false;
      errorslogin["email"] = "Please Enter Email Address";
    }
    if (typeof fieldslogin["email"] !== "undefined" && fieldslogin["email"] !== "") {
      let lastAtPos = fieldslogin["email"].lastIndexOf('@');
      let lastDotPos = fieldslogin["email"].lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldslogin["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fieldslogin["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errorslogin["email"] = "Enter valid email!";
      }
    }
    //Password
    if (!fieldslogin["password"]) {
      formIsValid = false;
      errorslogin["password"] = "Please Enter Password!";
    }
    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  componentDidMount() {
    document.title = "Jaipur Physio";


  }

  onClickMenu = (url) => {
    // console.log("url:", url);
    this.props.history.push(url)
  }

  otpSubmit = (e) => {
    e.preventDefault();
    if (this.handleValidationOTP()) {
      let { token } = this.props.registeruser;
      let { OTP } = this.state;
      this.props.dispatch(userActions.validateLoginOtp({
        token: token,
        otp: OTP
      }, this.props));
    }
  }

  handleValidationOTP = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Name
    if (!fieldslogin["OTP"]) {
      formIsValid = false;
      errorslogin["OTP"] = "please enter OTP!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  setCurrentCount = (data) => {
    this.setState({ currentCount: data });

  };
  //left drawer


  toggleMobileMenu = () => {
    this.setState(prevState => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen
    }));
  };

  render() {

    AOS.init();

    let { loading } = this.props;


    return (
      <>

        <Helmet>
          <title>Create Your Physio Profile with UR Physio to reach more patients | UR Physio</title>
          <meta
            name="description"
            content="Create your Physiotherapy Clinic profile effortlessly and at your convenience with UR Physio. Streamline your professional presence and reach more patients seamlessly."
          />
        </Helmet>

        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        {/* Whole Structure */}
        <div className="h-screen overflow-y-auto overflow-x-hidden w-screen relative bg-[#95CCC5]">
          {/* header sectio  start*/}
          <div className=" overflow-hidden sticky top-0 z-50">
            <div className="h-20 flex items-center justify-between w-11/12 mx-auto 2xl:w-9/12 xl:w-5/6">
              <a href="#" >
                <img className="w-40 md:w-56 " src="https://www.urphysio.in/img/logo3.webp" alt="Logo" />
              </a>
              <div className="lg:flex hidden gap-4 items-center">
                <button onClick={() => this.onClickMenu('/physio/login')} className="text-white bg-[#005F60] px-3 py-1 uppercase cursor-pointer transition-all ease-linear hover:scale-[1.01]">Join as Physio</button>
                <button onClick={() => this.onClickMenu('/hospital/login')} className="text-white bg-[#005F60] px-3 py-1 uppercase cursor-pointer transition-all ease-linear hover:scale-[1.01]">Join as Hospital/Clinic</button>
                <div className="text-[#005F60] text-lg uppercase">+91 87690 22385</div>
              </div>
              {/* Mobile Menu Icon */}
              <div className="lg:hidden flex">
                <button onClick={this.toggleMobileMenu} className="text-[#005F60]">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    {this.state.isMobileMenuOpen ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                    )}
                  </svg>
                </button>
              </div>
            </div>
            {/* Mobile Menu */}
            {this.state.isMobileMenuOpen && (
              <div className="lg:hidden block py-2 px-7 bg-white">
                <div className="grid grid-cols-2 gap-2">
                  <button onClick={() => this.onClickMenu('/physio/login')} className="bg-[#005F60] text-white text-xs font-semibold py-2 px-6 capitalize cursor-pointer transition-all hover:scale-[1.2]">Join as Physio</button>
                  <button onClick={() => this.onClickMenu('/hospital/login')} className="bg-[#005F60] text-white text-xs font-semibold py-2 px-6 capitalize cursor-pointer transition-all hover:scale-[1.2]">Join as Hospitalic</button>
                  <button className="bg-[#005F60] text-white text-xs font-semibold py-2 px-6 capitalize cursor-pointer transition-all hover:scale-[1.2]">+91-9798465132</button>
                </div>
              </div>
            )}
          </div>
          {/* header sectio  end*/}

          {/* hero section start  */}
          <div className="w-full  bg-gradient-to-b from-[#FFFFFF] to-[#95CCC5]" >
            <div className="flex md:flex-row flex-col items-center w-11/12 mx-auto 2xl:w-9/12 xl:w-5/6 h-fit pb-10" >
              <div className="w-full space-y-2 md:text-left text-center" >
                <h1 className="lg:text-4xl text-2xl font-bold text-[#005F60] uppercase" >The best way to grow your practice and professional network.</h1>
                <p className="text-[#005F60] text-xl" >Magical products for medical experts to connect among themselves and with patients faster</p>
                <div className="flex items-center  space-x-4 py-6 text-xl" >
                  <button className="rounded-full px-6 py-2 text-[rgb(0,95,96)] border-2 border-[#005F60] inline-flex items-center" onClick={() => this.onClickMenu('/physio/login')} >Physio <span className="pl-2"><AiOutlineArrowRight /></span> </button>
                  <button className="rounded-full px-6 py-2 text-white bg-[#005F60] flex items-center" onClick={() => this.onClickMenu('/hospital/login')}> Hospital/Clinic <span className="pl-2"><AiOutlineArrowRight /></span></button>
                </div>

              </div>
              <div className="md:flex hidden justify-end relative items-center w-full lg:pt-20" >
                <img src="https://urphysio.in/images1/image-1712645016489.png" className=" rounded-2xl" alt="shark" width={400} height={400} />
              </div>
            </div>

          </div>


          <footer className="bg-[#000] absolute bottom-0 w-full">
            <div className="mx-auto 2xl:w-9/12 xl:w-5/6 w-11/12">
              <a href="#" className="flex justify-center py-4">
                <img src="https://www.urphysio.in/img/logo1.webp" alt="" width={80} height={70} />
              </a>
              <hr className=" border-gray-200 sm:mx-auto dark:border-gray-700" />
              <div className="lg:flex lg:items-center lg:justify-between py-4">
                <div className="flex lg:justify-start justify-center space-x-6 text-xl text-white/80 lg:py-0 py-4">
                  <a href="https://www.facebook.com/people/UR-Physio/61557863561817/" target="_blank" rel="noreferrer">
                    <FaFacebookF className="text-white hover:text-[#ed117f] cursor-pointer transition-all duration-150" />
                  </a>
                  <a href="https://twitter.com/urphysio_" target="_blank" rel="noreferrer">
                    <BsTwitter className="text-white hover:text-[#ed117f] cursor-pointer transition-all duration-150" />
                  </a>
                  <a href="https://www.instagram.com/urphysio_/" target="_blank" rel="noreferrer">
                    <IoLogoInstagram className="text-white hover:text-[#ed117f] cursor-pointer transition-all duration-150" />
                  </a>
                  <a href="https://www.linkedin.com/company/urphysio/" target="_blank" rel="noreferrer">
                    <FaLinkedinIn className="text-white hover:text-[#ed117f] cursor-pointer transition-all duration-150" />
                  </a>
                </div>
                <ul className="flex leading-[2rem] flex-wrap lg:justify-start justify-center items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400 space-x-3">
                  <li>
                    <a href="mailto:urphysiojaipur@gmail.com" className="text-white hover:text-[#ed117f] inline-flex items-center cursor-pointer transition-all duration-150"><span className="pr-2"><MdMailOutline size={24} /></span>urphysiojaipur@gmail.com</a>
                  </li>
                  <li>
                    <a href="mailto:support@urphysio.in" className="text-white hover:text-[#ed117f] inline-flex items-center cursor-pointer transition-all duration-150"><span className="pr-2"><MdOutlineSupportAgent size={24} /></span>support@urphysio.in</a>
                  </li>
                </ul>
              </div>

            </div>
            <section className="bg-[#4F8F8F] py-2">
              <div className="flex justify-between items-center mx-auto 2xl:w-9/12 xl:w-5/6 w-11/12">
                <span className="md:text-sm text-xs text-[#fff] text-center font-bold">© Copyright 2024 UR Physio | All Rights Reserved.</span>
                {/* <a href="https://www.urphysio.in" target="_blank" className="md:text-sm text-xs text-[#fff] text-center font-bold">Join Our Team</a> */}
              </div>
            </section>
          </footer>

        </div>
        {/* Whole Structure End*/}
      </>
    )
  }
}
function mapStateToProps(state) {
  const { loggingIn, user, otpSentLogin, registeruser, loading } = state.authentication;
  const { users, authentication } = state;
  return {
    loggingIn,
    otpSentLogin,
    user,
    users,
    registeruser,
    loading,
    authentication
  };
}
export default connect(mapStateToProps)(Home);
// export default NetworkDetector(connect(mapStateToProps)(Home));</div>lg: